<template>
	<div style="text-align: left;padding: 100px;position: relative;">
		<!--支付成功-->
		<!--<div></div>-->
		<!--<el-alert title="支付成功" type="success">-->
		<div class="succ-box">
			<el-alert style="font-size: 15;"  type="success" show-icon>
				<p solt="title" style="font-size: 18px;">
				支付成功	
				</p>
				<p style="font-size: 15px;">
					恭喜您，您的码标注册之旅已经完成，感谢您的支持！
				</p>
				
			</el-alert>
			<p class="tit-errer">注：该码标处于审核期，在此期间如果发现该码标存在违规现象，平台会将码标收回，如果您已缴费，平台会将费用原路退还。</p>
			<!--注册成功之日起{{time}}日内-->
			<div class="operation-box">
				<el-button type="primary" plain v-if="incomplete"   @click="$router.push('perfect') ">完善资料</el-button>
				<el-button type="primary" plain @click="$router.push('enterprisemb')">查看码标</el-button>

			</div>
		</div>
		<img src="../assets/imgs/03.png" style="position: absolute; right: 9%;display: inline-block;top: 100px;" />
		<!--</el-alert>-->
	</div>
</template>

<script>
	export default {
		data() {
			return {
				protect: true,
				time: 0,
			}
		},
		computed: {
			incomplete() {
				return this.$store.state.commonalityData.IdcodeUserId === '' ? true : false
			}
		},
		created() {
			this.verify()
		},
		methods: {
			verify() {
				//支付宝返回信息通知
				this.$http.post(this.$api + '/identificationApply/identificationPayQuery', {
					outTradeNo: this.$GetQueryString('out_trade_no')
				}).then(res => {
//					console.log(res.body)
				})
//				this.$http.get(this.$api + '/baseData/getProtectedTime').then(res => {
//					//            	isProtected
//					if(res.body.result === 1) {
//						this.protect = res.body.entity.isProtected === 0 ? true : false;
//						this.time = res.body.entity.time
//
//					}
//
//				}, rej => {
//
//				})
			}

		}
	}
</script>

<style lang="scss">
	.succ-box {
		width: 70%;
		/*margin: 0 auto;*/
		.el-alert__description{
		font-size: 15px;
	}
	}
	.el-alert .el-alert__description{
		font-size: 15px;
		
	}
	.tit-errer {
		margin: 20px 0;
		font-size: 14px;
		color: #f56c6c;
	}
	
</style>